import { rgba, cssVar } from "polished";
import antdVars from "./antd.json";

const colorsHelper = () => {
  const defaultValue = "#fff";
  return {
    "--color-feedback-warning-400": cssVar("--color-feedback-warning-400", defaultValue),
    "--opacity-level-5": cssVar("--opacity-level-5", defaultValue),
    "--opacity-level-4": cssVar("--opacity-level-4", defaultValue),
    "--opacity-level-1": cssVar("--opacity-level-1", defaultValue),
  };
};

const theme = {
  colors: {
    defaultBackground: "var(--color-neutral-100)",
    background: "var(--color-neutral-200)",
    text: "var(--color-contrast-brand)",
    manatee: "var(--color-neutral-400)",
    shuttleGray: "var(--color-neutral-400)",
    loblolly: "var(--color-neutral-200)",
    toltip: "var(--color-brand-300)",
    backgroundColorLight: rgba(colorsHelper()["--color-feedback-warning-400"], Number(colorsHelper()["--opacity-level-5"])),
    backgroundColorLightHover: rgba(colorsHelper()["--color-feedback-warning-400"], Number(colorsHelper()["--opacity-level-4"])),
    backgroundColorHover: rgba(colorsHelper()["--color-feedback-warning-400"], Number(colorsHelper()["--opacity-level-1"])),
    formColorIcons: "var(--color-neutral-400)",
    iconActionbackgroundColor: "var(--color-neutral-400)",
    aquaHaze: "var(--color-neutral-background)",
    westSide: "var(--color-feedback-warning-300)",
    grayTag: "var(--color-neutral-200)",
    grayCard: "var(--color-neutral-background)",
  },
  ...antdVars,
};

export default theme;
